import { useAvaPush } from '../../../hooks/useAvaPush';
import '../../../styles/AvaPush.css';

// Compact "enable browser notifications" control for the Ava (آوا) tab. Lets the
// admin opt into Web Push so reminders reach them even when the tab is closed.
// Renders nothing where push is unsupported; shows an install hint on iOS Safari.
export default function AvaPushToggle() {
  const { supported, subscribed, busy, error, iosBlocked, permission, enable, disable } = useAvaPush();
  if (!supported) return null;

  return (
    <div className="ava-push" dir="rtl">
      {iosBlocked ? (
        <span className="ava-push-hint">
          برای دریافت اعلانِ یادآوری‌ها روی iOS، ابتدا برنامه را از منوی Share با «Add to Home Screen» نصب کنید.
        </span>
      ) : permission === 'denied' ? (
        <span className="ava-push-hint">
          اعلان‌ها در مرورگر مسدود شده‌اند. برای دریافت یادآوری حتی با تبِ بسته، از تنظیمات سایت اجازه دهید.
        </span>
      ) : subscribed ? (
        <button type="button" className="ava-push-btn ava-push-on" onClick={disable} disabled={busy} title="غیرفعال‌سازی اعلان مرورگر">
          <BellIcon />
          {busy ? 'در حال تغییر...' : 'اعلان مرورگر فعال است'}
        </button>
      ) : (
        <button type="button" className="ava-push-btn" onClick={enable} disabled={busy} title="یادآوری‌ها حتی با تبِ بسته به شما برسد">
          <BellIcon />
          {busy ? 'در حال فعال‌سازی...' : 'فعال‌سازی اعلان مرورگر'}
        </button>
      )}
      {error && <span className="ava-push-error" role="alert">{error}</span>}
    </div>
  );
}

function BellIcon() {
  return (
    <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">
      <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
      <path d="M13.73 21a2 2 0 0 1-3.46 0" />
    </svg>
  );
}
